import { css } from '@emotion/react'
import { ThemeUI } from '../../../theme'
import { StyleProps } from './types'

type Props = { theme: ThemeUI } & StyleProps

const rootContainer = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 18px;
`

const label = ({ theme }: Props) => css`
  font-size: 11px;
  line-height: 14px;
  margin-bottom: 8px;
  text-transform: uppercase;
  font-weight: 800;
  color: #0f172a;
  letter-spacing: 0.04em;
`

const hint = ({ theme, success, error }: Props) => css`
  font-size: 11px;
  line-height: 14px;
  margin-top: 6px;
  text-align: right;
  ${success && `color: ${theme.palette.success};`}
  ${error && `color: ${theme.palette.danger};`}
`

const input = ({ theme, success, error }: Props) => css`
  background-color: ${success ? "#f0fdf4" : error ? "#fef2f2" : "#ffffff"};
  border: 1px solid ${error ? "#f97316" : success ? "#10b981" : "#d8dee9"};
  width: 100%;
  font-family: "Lato", sans-serif;
  font-size: 14px;
  line-height: 20px;
  border-radius: 12px;
  padding: 14px 44px 14px 16px;
  resize: vertical;
  min-height: 140px;
  color: #0f172a;
  transition: all 0.18s ease;

  &:focus {
    outline: none;
    border-color: #34189a;
    box-shadow: 0 0 0 4px rgba(52, 24, 154, 0.08);
    background: #ffffff;
  }

  &:disabled {
    background-color: ${theme.palette.secondary10};
  }
`

const inputContainer = css`
  position: relative;

  & svg {
    position: absolute;
    right: 16px;
    top: 24px;
  }
`

export { rootContainer, label, hint, input, inputContainer }